<template>
  <iColumn
    class="chatroom-thread-container"
    gap="none"
    height="fill"
    wrap="nowrap"
  >
    <iRow height="fill" overflow="scroll">
      <ConversationThread ref="conversationThread" :entity-id="entityId" :context="context" />
    </iRow>
    <CreateMessage :entity-id="entityId" :context="context" />
  </iColumn>
</template>

<script>
import ConversationThread from "%/apps/conversations/components/ConversationThread.vue";
import CreateMessage from "%/apps/conversations/components/message/CreateMessage.vue";

export default {
  name: "Conversation2",
  components: { CreateMessage, ConversationThread },
  props: {
    context: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },
};
</script>
